import React from "react";
import { Typography, Box, Button, Link } from "@mui/material";
import BaseModal from "./BaseModal";
import GradientButton from "../gradients/GradientButton";
import { useLocation } from "react-router-dom";
import BaseDrawer from "./mobile/BaseDrawer";

export const btnStyle = {
  minHeight: "45px",
  fontSize: "15px",
};

const USER_TEXT = "Your design has been added to your bag!";

const GuestDisclaimer = ({ onAction, isMobile }) => (
  <>
    <Typography variant={isMobile ? "h2" : "h3"}>Feeling inspired?</Typography>
    <Link onClick={() => onAction({ type: "SIGN_IN" })}>Sign In</Link> or{" "}
    <Link onClick={() => onAction({ type: "SIGN_UP" })}>Sign Up</Link> to keep shopping and create
    your next design.
  </>
);

export const AddToBagDisclaimerModal = ({
  onClose,
  handleCreateCheckout,
  isMobile = false,
  customer,
  onModalAction,
}) => {
  const location = useLocation();
  const isEditOrder = JSON.parse(sessionStorage.getItem(location.pathname))?.length > 0;

  const computedDisclaimerText = React.useMemo(
    () => (customer ? USER_TEXT : <GuestDisclaimer onAction={onModalAction} isMobile={isMobile} />),
    [customer]
  );

  const handleCheckout = () => {
    if (isEditOrder) {
      sessionStorage.removeItem(location.pathname);
    }

    handleCreateCheckout(false);
    onClose();
  };

  const handleAddAndKeepShopping = () => {
    if (!customer) {
      onModalAction({ type: "SIGN_IN" });
      return;
    }

    if (isEditOrder) {
      sessionStorage.removeItem(location.pathname);
    }

    handleCreateCheckout(true);
    onClose();
  };

  return (
    <>
      {isMobile ? (
        <BaseDrawer onClose={onClose}>
          <Box sx={{ padding: "50px 0px" }}>
            <Typography
              variant={customer ? "h3" : undefined}
              sx={{ fontSize: "30px", textAlign: "center", marginBottom: "25px" }}
            >
              {computedDisclaimerText}
            </Typography>

            <Box
              sx={{ display: "flex", flexDirection: "column", gap: "20px", alignItems: "center" }}
            >
              <GradientButton addStyle={btnStyle} onClick={handleAddAndKeepShopping}>
                Keep Shopping
              </GradientButton>
              <Typography variant="inherit">OR</Typography>
              <GradientButton addStyle={btnStyle} onClick={handleCheckout}>
                Checkout
              </GradientButton>
            </Box>
          </Box>
        </BaseDrawer>
      ) : (
        <BaseModal headline="" onClose={onClose} gradient={true}>
          <Box sx={{ padding: "50px 0px" }}>
            <Typography
              variant={customer ? "h3" : undefined}
              sx={
                customer
                  ? { fontSize: "20px", textAlign: "center", marginBottom: "25px" }
                  : { textAlign: "center" }
              }
            >
              {computedDisclaimerText}
            </Typography>

            <Box sx={{ textAlign: "center", marginTop: "10px" }}>
              <Button
                variant="contained"
                sx={{ marginRight: "10px" }}
                onClick={handleAddAndKeepShopping}
              >
                Add to Bag and Keep Shopping
              </Button>

              <GradientButton onClick={handleCheckout}>Checkout</GradientButton>
            </Box>
          </Box>
        </BaseModal>
      )}
    </>
  );
};

export default AddToBagDisclaimerModal;
